import { uniqBy } from 'lodash';

import { CommonVisitParameters, Visit } from '@dreryk/egabinet-visit-frontend-api';

import { Choice } from '@dreryk/watermelon';
import { TextEditorValue } from '@dreryk/react-text-editor';

import { DiagnosisTableBean } from './tabs/diagnoses/DiagnosesFormTab.types';
import { mapDiagnosesToDiagnosesFormBeanPart } from './tabs/diagnoses/DiagnosesFormTab.utils';
import { safeProcedureQuantity } from './tabs/procedures/procedures.utils';
import { VisitFormBean } from './visitForm.types';

export const createCommonVisitParameters = (visitDetails: VisitFormBean): CommonVisitParameters => {
   return {
      interview: Choice.withUseDefaultIfNull(visitDetails.interview?.getFormattedValue() ?? null),
      physicalExamination: Choice.withUseDefaultIfNull(visitDetails.subjectiveAssessments?.getFormattedValue() ?? null),
      recommendations: Choice.withUseDefaultIfNull(visitDetails.recommendations?.getFormattedValue() ?? null),
      procedures: uniqBy(
         visitDetails.procedures.value.map((procedure) => ({
            code: procedure.code,
            quantity: safeProcedureQuantity(procedure.quantity),
            minQuantity: procedure.minQuantity,
         })),
         'code'
      ),
   };
};

export const mapVisitToVisitFormBean = (visit: Visit): VisitFormBean => {
   return {
      interview: visit.visitDetails.interview ? TextEditorValue.fromFormatted(visit.visitDetails.interview) : null,
      subjectiveAssessments: visit.visitDetails.physicalExamination
         ? TextEditorValue.fromFormatted(visit.visitDetails?.physicalExamination)
         : null,
      recommendations: visit.visitDetails.recommendations
         ? TextEditorValue.fromFormatted(visit.visitDetails?.recommendations)
         : null,
      ...mapDiagnosesToDiagnosesFormBeanPart(
         visit.diagnoses.map(
            (diagnosis): DiagnosisTableBean => {
               return {
                  additionalInformation: diagnosis.additionalInformation ?? null,
                  code: diagnosis.icd10Code,
                  name: diagnosis.name,
                  main: diagnosis.main,
                  chronic: diagnosis.chronic,
               };
            }
         )
      ),
      procedures: {
         search: null,
         value: visit.procedures.map((procedure) => ({
            name: procedure.name,
            code: procedure.code,
            quantity: procedure.quantity,
            validQuantity: procedure.quantity,
            minQuantity: procedure.minQuantity,
         })),
      },
      medicalImaging: undefined,
   };
};
